// extracted by mini-css-extract-plugin
export default {"body":"item_body__uyFOh","ticketItem":"item_ticketItem__WYoSW","wrapper":"item_wrapper__dv0UF","btns":"item_btns__hYnkV"};